module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp2_5010.6b035fb9.png";